import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=448f9994&scoped=true&"
import script from "./RecentNews.vue?vue&type=script&lang=js&"
export * from "./RecentNews.vue?vue&type=script&lang=js&"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=448f9994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f9994",
  null
  
)

export default component.exports